(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nirus-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-np]');
    if (!raiz) return;

    // ---- galeria ----
    var slides = raiz.querySelectorAll('[data-np-slide]');
    var thumbs = raiz.querySelectorAll('[data-np-goto]');
    var i = 0;
    function ir(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { ir(+t.dataset.npGoto); }); });
    var pv = raiz.querySelector('[data-np-prev]'), nx = raiz.querySelector('[data-np-next]');
    if (pv) pv.addEventListener('click', function () { ir(i - 1); });
    if (nx) nx.addEventListener('click', function () { ir(i + 1); });

    // ---- cuenta regresiva a una fecha REAL (no se reinicia) ----
    var reloj = raiz.querySelector('[data-np-cuenta]');
    if (reloj) {
      var fin = new Date(reloj.dataset.npCuenta).getTime();
      (function tic() {
        var falta = fin - Date.now();
        if (isNaN(fin)) { reloj.remove(); return; }
        if (falta <= 0) { reloj.textContent = ''; return; }
        var d = Math.floor(falta / 86400000), h = Math.floor(falta % 86400000 / 3600000),
            m = Math.floor(falta % 3600000 / 60000), s = Math.floor(falta % 60000 / 1000);
        reloj.textContent = (d ? d + 'd ' : '') + ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2) + ':' + ('0' + s).slice(-2);
        setTimeout(tic, 1000);
      })();
    }

    // ---- precio de la barra fija sigue al pack elegido ----
    var form = raiz.querySelector('[data-np-form]');
    var fijaPrecio = raiz.querySelector('[data-np-fija-precio]');
    function precioElegido() {
      var el = form && form.querySelector('input[name="id"]:checked');
      if (!el) return null;
      var pr = el.closest('.np-pack').querySelector('.np-pack__now');
      return pr ? pr.textContent : null;
    }
    if (form) {
      form.addEventListener('change', function () {
        var t = precioElegido();
        if (t && fijaPrecio) fijaPrecio.textContent = t;
      });
      var t0 = precioElegido();
      if (t0 && fijaPrecio) fijaPrecio.textContent = t0;
    }

    // ---- avisarle a Horizon que el carrito cambio ----
    // 🔑 Horizon escucha UN SOLO evento y se llama 'cart:update' (ThemeEvents.cartUpdate
    // en assets/events.js). CartAddEvent y CartUpdateEvent usan ese mismo nombre.
    // El contenido del drawer lo dibuja el SERVIDOR: si no se dispara el evento, el
    // drawer abre con el HTML de cuando cargo la pagina — o sea vacio — aunque el item
    // ya este en el carrito. Eso era el bug: aca se disparaba 'cart:refresh', que no
    // existe en el tema, y nadie lo escuchaba.
    // Forma del detail (sacada de cart-icon.js y component-cart-items.js del tema):
    //   detail.data.itemCount  -> la burbuja del header. Es ABSOLUTO salvo que
    //                             detail.data.source sea 'product-form-component',
    //                             caso en que el tema lo SUMA al valor actual.
    //                             Mandamos el total y no mandamos source.
    //   detail.data.sections   -> si falta, cart-items pide la seccion al servidor
    //                             (sectionRenderer.renderSection) y se redibuja solo.
    function avisarCarrito(carrito) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: carrito, sourceId: 'nirus-pdp', data: { itemCount: carrito.item_count } }
      }));
      var cj = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer');
      if (cj && typeof cj.open === 'function') cj.open();
    }

    // ---- agregar al carrito por AJAX ----
    function agregar(boton) {
      var el = form.querySelector('input[name="id"]:checked');
      if (!el || !window.fetch) { form.submit(); return; }
      boton.disabled = true;
      var raizU = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(raizU + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(el.value), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          if (boton.dataset.ok) boton.textContent = boton.dataset.ok;
          return fetch(raizU + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (carrito) { avisarCarrito(carrito); });
        })
        .then(function () {
          setTimeout(function () {
            if (boton.dataset.txt) boton.textContent = boton.dataset.txt;
            boton.disabled = false;
          }, 1600);
        }).catch(function () { boton.disabled = false; form.submit(); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); agregar(raiz.querySelector('[data-np-atc]')); });
    var bf = raiz.querySelector('[data-np-fija-add]');
    if (bf) bf.addEventListener('click', function () { agregar(bf); });

    // ---- barra fija: aparece cuando el boton principal sale de pantalla ----
    var fija = raiz.querySelector('[data-np-fija]');
    var atc = raiz.querySelector('[data-np-atc]');
    if (fija && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        fija.hidden = es[0].isIntersecting || es[0].boundingClientRect.top > 0;
      }, { rootMargin: '0px' }).observe(atc);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nirus-ticker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var vids = document.querySelectorAll('.nt-video');
    if (!vids.length) return;
    function arrancar(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(arrancar); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.preload = 'auto'; arrancar(e.target); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.1 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nirus-videos"] && !Shopify.designMode) return;
  try {
    
  // Los videos arrancan cuando entran en pantalla y se frenan al salir: no quema bateria
  // ni ancho de banda en telefono, y en iOS el autoplay mudo necesita el play() explicito.
  (function () {
    var vids = document.querySelectorAll('.nv-video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  } catch(e) { console.error(e); }
})();
})();
